const BYTE_UNITS = ["B", "KiB", "MiB", "GiB", "TiB", "PiB"] as const;

/**
 * Formats a byte count as a human-readable string (e.g. "5.1 GiB", "24 MiB").
 *
 * Uses IEC binary units (1024 base) which is the standard for storage/ingestion.
 * Safe for bigint up to ~9 PiB (Number.MAX_SAFE_INTEGER); larger values may lose
 * decimal precision.
 *
 * @param bytes - Byte count as bigint (e.g. totalIngestionBytes from GetTenantUsageResponse)
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted string like "5.1 GiB" or "0 B"
 */
export function formatBytes(bytes: bigint | undefined, decimals = 1): string {
  if (bytes === undefined) {
    return "—";
  }

  if (bytes === 0n) {
    return "0 B";
  }

  const k = 1024;
  const i = Math.min(Math.floor(Math.log2(Number(bytes)) / 10), BYTE_UNITS.length - 1);

  const value = Number(bytes) / Math.pow(k, i);
  const formatted = value.toFixed(decimals).replace(/\.?0+$/, "");

  return `${formatted} ${BYTE_UNITS[i]}`;
}
